<template>
  <div>
    <div class="cmp-handle" style="z-index: 999">
      <el-dropdown>
        <span class="el-dropdown-link">
          <i class="el-input__icon el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="settingVisible=true"
                            style="text-align: center">设置
          </el-dropdown-item>
          <el-dropdown-item @click.native="handleCmp('delete',componentIndex)"
                            style="text-align: center">删除
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-tooltip :content="uDataSources.text" placement="top-start" :open-delay="1000">
      <p @dblclick="(event)=>dbClick(event,uDataSources.key)"
         v-show="!edit" :style="`${'cursor: pointer; font-size: '+fontSize +'px;color: '+fontColor}`">{{uDataSources.text}}</p>
    </el-tooltip>
    <div>
      <Icon @click="clickEvent" :style="`${'font-size: 36px;color: '+powerColor}`" type="ios-power"/>
      <Icon @click="clickEvent" :style="`${'font-size: 36px;color: '+powerColor}`" type="ios-radio-button-on"/>
      <Icon @click="clickEvent" :style="`${'font-size: 36px;color: '+powerColor}`" type="ios-square"/>
      <el-checkbox v-model="on"></el-checkbox>
    </div>
    <el-dialog
        :append-to-body="true"
        :visible.sync="settingVisible"
        title="设置"
        width="30%">
      <el-tabs>
        <el-tab-pane label="信号名设置">
          <el-row>
            <el-col :span="8">
              <span style="font-size: 16px;display: block">字体大小</span>
              <el-input-number size="mini" v-model="exampleFontSize" :min="12" :max="30" controls-position="right" style="width: 80%"></el-input-number>
            </el-col>
            <el-col :span="8">
              <span style="font-size: 16px;display: block">颜色</span>
              <el-color-picker size="mini" v-model="exampleFontColor" show-alpha></el-color-picker>
            </el-col>
            <el-col :span="8">
              <span style="font-size: 16px;display: block">预览</span>
              <span :style="`${'font-size: '+exampleFontSize +'px;color: '+exampleFontColor}`">信号名</span>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="布尔控件设置">
          <el-row>
            <el-col :span="24">
              <el-switch
                  v-model="triggerButton"
                  active-text="触发型"
                  inactive-text="锁止型">
              </el-switch>
            </el-col>
          </el-row>
          <br>
          <el-row>
            <el-col :span="16">
              <span style="font-size: 16px;display: block">True颜色</span>
              <el-color-picker v-model="onColor" show-alpha></el-color-picker>
            </el-col>
            <el-col :span="8">
              <span style="font-size: 16px;display: block">预览</span>
              <Icon :style="`${'font-size: 36px;color: '+onColor}`" type="ios-power"/>
            </el-col>
          </el-row>
          <br>
          <el-row>
            <el-col :span="16">
              <span style="font-size: 16px;display: block">False颜色</span>
              <el-color-picker v-model="offColor" show-alpha></el-color-picker>
            </el-col>
            <el-col :span="8">
              <span style="font-size: 16px;display: block">预览</span>
              <Icon :style="`${'font-size: 36px;color: '+offColor}`" type="ios-power"/>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <span class="dialog-footer" slot="footer">
        <el-button @click="settingVisible = false">取 消</el-button>
        <el-button @click="settingVisible = false" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';

export default {
  name: 'Boolean',
  props: {
    componentIndex: {
      type: Number,
    },
  },
  data() {
    return {
      edit: false,
      on: false,
      settingVisible: false,
      onColor: '#F56C6C',
      offColor: '#303133',
      fontColor: '#303133',
      exampleFontColor: '#303133',
      fontSize: 15,
      exampleFontSize: 15,
      triggerButton: false,
      uDataSources: {
        text: '信号名',
        key: '',
        value: 0,
      },

    };
  },
  methods: {
    ...mapActions('Engineering', ['deleteCpt']),
    ...mapMutations('Engineering', ['setAnchorKeyWord', 'setAnchorPointId']),
    handleCmp(command, index) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      switch (command) {
        case 'delete':
          this.deleteCpt({ index });
          break;
        default:
          break;
      }
    },
    dbClick(event, key) {
      event.stopPropagation();
      const arr = key.split('.');
      const str = arr.join('');
      const arr2 = str.split(':');
      const str2 = arr2.join('');
      this.setAnchorKeyWord(key.substring(key.lastIndexOf('.') + 1)); // 信号名
      setTimeout(() => {
        this.setAnchorKeyWord('');
        this.setAnchorPointId('');
        setTimeout(() => {
          this.setAnchorPointId(str2);
        }, 50);
      }, 50);
    },
    clickEvent() {
      this.on = !this.on;
      if (this.triggerButton) {
        setTimeout(() => {
          this.on = !this.on;
        }, 300);
      }
    },
  },
  computed: {
    ...mapGetters('Engineering', ['getCurCmpStatus']),
    powerColor() {
      const on = this.on;
      if (on) {
        return this.onColor;
      }
      return this.offColor;
    },
  },
};
</script>

<style scoped>
  .el-input__icon {
    line-height: 25px;
    opacity:0;
  }
  .cmp-handle {
    position: absolute;
    top: 0;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/engineering/Boolean.vue